import { GetReportsResponse } from '../types'

export const checkReportNameExists = (
    name: string,
    reports: GetReportsResponse
): boolean => {
    if (!reports.items.length) return false

    const normalizedName = name.trim().toLowerCase()
    return reports.items.some(
        (report) => report.name.trim().toLowerCase() === normalizedName
    )
}
